module.exports = __webpack_public_path__ + "img/SKMJ_check9.d071f301.png";